<ui-card type="raised" [ngClass]="{ 'main-card': mainCard }">
    <card-body>
        <h5 class="mt-1">
            <ui-icon type="action" icon="malware-scan" class="mr-1"></ui-icon>
            <span id="span_1681893376">{{'dashboard.threats.details.info.title' | translate}}</span>
        </h5>
        <p id="p_1652856467" class="color-shade-60" [innerHTML]="'dashboard.threats.details.info.description' | translate: {hotForSecurityLink: hotForSecurityLink }"></p>
    </card-body>
</ui-card>